// Client store + writer for Activity favorites. Shared reactive list (useState),
// optimistic toggle with revert-on-error. A logged-out toggle routes to /login
// (matching the session "Add to My Schedule" behavior in useScheduleAction.js).
export const useActivityFavorites = () => {
    const favorites = useState('activity-favorites', () => []);
    const { loggedIn } = useUserSession();

    const loadFavorites = async () => {
        try {
            const { favorites: ids } = await $fetch('/api/v1/activities/favorites');
            favorites.value = ids || [];
        } catch {
            favorites.value = [];
        }
    };

    const isFavorited = (activityId) => favorites.value.includes(activityId);

    const toggleFavorite = async (activityId) => {
        if (!loggedIn.value) {
            await navigateTo('/login');
            return;
        }
        const wasFavorited = favorites.value.includes(activityId);
        const next = !wasFavorited;
        // optimistic
        favorites.value = next
            ? [...favorites.value, activityId]
            : favorites.value.filter((id) => id !== activityId);
        try {
            const { favorites: ids } = await $fetch('/api/v1/activities/favorites', {
                method: 'POST',
                body: { activityId, favorited: next },
            });
            if (Array.isArray(ids)) favorites.value = ids;
        } catch (e) {
            // revert to pre-click state
            favorites.value = wasFavorited
                ? [...favorites.value, activityId]
                : favorites.value.filter((id) => id !== activityId);
            if (e?.statusCode === 401 || e?.response?.status === 401) await navigateTo('/login');
        }
    };

    return { favorites, loadFavorites, isFavorited, toggleFavorite };
};
